<template>

    <div class="page-wrapper">

       <!-- Menu Superior de Navegación -->
       <navbar-new></navbar-new>
       
       <header-contact></header-contact>
      
       <contact-us></contact-us>

       <contact-one></contact-one>

       <google-contact></google-contact>

       <!-- Pie de Página -->
       <footer-new></footer-new>
        

    </div>
</template>
  
<script>
  import navbarNew from '../components/navbar.vue'

  import headerContact from '../components/contact/headerContact.vue'

  import contactUs from '../components/contact/contactUs.vue'

  import googleContact from '../components/contact/googleContact.vue'

  import contactOne from '../components/contact/contactOne.vue'


  import footerNew from '../components/footer.vue'

  export default {
    components: {
    navbarNew,
    headerContact,
    contactUs,
    contactOne,
    googleContact,
    footerNew
  }
  }
  
</script>
  